// Use public folder URLs for lazy loading - not bundled in JS
const integrations = [
  { name: "n8n", icon: "🔄", description: "Workflow Automation", image: "/images/integrations/n8n.webp" },
  { name: "OpenAI", icon: "🤖", description: "AI & Machine Learning", image: "/images/integrations/openai.webp" },
  { name: "Zapier", icon: "⚡", description: "App Integration", image: "/images/integrations/zapier.webp" },
  { name: "Make", icon: "🛠️", description: "Visual Automation", image: "/images/integrations/make.webp" },
  { name: "Notion", icon: "📝", description: "Productivity", image: "/images/integrations/notion.webp" },
  { name: "Google Sheets", icon: "📊", description: "Data Management", image: "/images/integrations/sheet.webp" },
  { name: "Gmail", icon: "📧", description: "Email Automation", image: "/images/integrations/email.webp" },
  { name: "Slack", icon: "💬", description: "Team Communication", image: "/images/integrations/slack.webp" },
  { name: "Discord", icon: "🎮", description: "Community Management", image: "/images/integrations/discord.webp" },
  { name: "Telegram", icon: "📱", description: "Messaging", image: "/images/integrations/telegram.webp" },
  { name: "Twilio", icon: "📞", description: "SMS & Voice", image: "/images/integrations/twilio.webp" },
  { name: "Stripe", icon: "💳", description: "Payments", image: "/images/integrations/stripe.webp" },
  { name: "Webhooks", icon: "🔗", description: "Custom Integrations", image: "/images/integrations/webhook.webp" },
  { name: "GitHub", icon: "🐙", description: "Development", image: "/images/integrations/github.webp" },
  { name: "WhatsApp", icon: "💬", description: "Messaging", image: "/images/integrations/whatsapp.webp" },
  { name: "Airtable", icon: "📋", description: "Database", image: "/images/integrations/airtable.webp" },
  { name: "Google Drive", icon: "☁️", description: "Cloud Storage", image: "/images/integrations/google-drive.webp" },
];

export function IntegrationsMarquee() {
  // Duplicate the array to create seamless loop
  const duplicatedIntegrations = [...integrations, ...integrations];

  return (
    <section className="py-20 bg-secondary/30 overflow-hidden">
      <div className="container mx-auto px-6 mb-12">
        <div className="text-center animate-fade-in">
          <h2 className="text-4xl font-bold mb-4">
            Plug AI into your own data &{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">
              over 500 integrations
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Connect with the tools you already use. Our templates work seamlessly with 
            popular platforms to create powerful automation workflows.
          </p>
        </div>
      </div>

      {/* First Row - Left to Right */}
      <div className="relative mb-8" style={{ contain: 'layout style paint' }}>
        <div className="flex animate-marquee hover:[animation-play-state:paused] gap-8 will-change-transform">
          {duplicatedIntegrations.map((integration, index) => (
            <div
              key={`row1-${index}`}
              className="flex-shrink-0"
            >
              <div className="flex items-center space-x-4 bg-card border border-border rounded-2xl px-6 py-4 shadow-lg hover:shadow-xl transition-shadow duration-300 hover:scale-105 min-w-[200px]">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-md overflow-hidden">
                  {integration.image ? (
                    <img 
                      src={integration.image} 
                      alt={integration.name} 
                      width="48"
                      height="48"
                      loading="lazy"
                      decoding="async"
                      className="w-12 h-12 object-cover" 
                    />
                  ) : (
                    <div className="w-full h-full bg-gradient-primary flex items-center justify-center">
                      <span className="text-white text-xl">{integration.icon}</span>
                    </div>
                  )}
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-sm">{integration.name}</h3>
                  <p className="text-xs text-muted-foreground">{integration.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Second Row - Right to Left */}
      <div className="relative" style={{ contain: 'layout style paint' }}>
        <div className="flex animate-marquee-reverse hover:[animation-play-state:paused] gap-8 will-change-transform">
          {duplicatedIntegrations.slice().reverse().map((integration, index) => (
            <div
              key={`row2-${index}`}
              className="flex-shrink-0"
            >
              <div className="flex items-center space-x-4 bg-card border border-border rounded-2xl px-6 py-4 shadow-lg hover:shadow-xl transition-shadow duration-300 hover:scale-105 min-w-[200px]">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-md border border-border overflow-hidden">
                  {integration.image ? (
                    <img 
                      src={integration.image} 
                      alt={integration.name}
                      width="48"
                      height="48"
                      loading="lazy"
                      decoding="async"
                      className="w-12 h-12 object-cover" 
                    />
                  ) : (
                    <div className="w-full h-full bg-gradient-secondary flex items-center justify-center">
                      <span className="text-foreground text-xl">{integration.icon}</span>
                    </div>
                  )}
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-sm">{integration.name}</h3>
                  <p className="text-xs text-muted-foreground">{integration.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}
